import { createRef, useEffect } from 'react';

/**
 * Scroll Intersection Trigger
 * @category Functional Component
 * @extends Component
 * @summary Detects viewport intersection via the intersection observer and fires a function.
 * @param {function} action The function to fire.
 * @return {Node} React node containing the scroll intersection trigger component.
 */

 const ScrollIntersectionTrigger = (props) => {
  const { children } = props;
  const scrollElement = createRef();

  useEffect(() => {
    const scrollElementRef = scrollElement.current;
    const io = new IntersectionObserver(
      entries => {
        const { action } = props;

        if(entries[0] && entries[0].isIntersecting) {
          action();
        }
      }, { threshold: 0, rootMargin: '0px 0px -50%' }
    );

    io.observe(scrollElementRef);

    return () => {
      io.unobserve(scrollElementRef);
      io.disconnect();
    };
  });

  return (
    <div ref={ scrollElement }>
      { children }
    </div>
  );
}

export default ScrollIntersectionTrigger;
